export default __webpack_public_path__ + "static/media/bones.ca1878cb.png";